module.exports = __webpack_public_path__ + "static/img/qr_douyin.93d49b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/qr_douyin.png
// module id = NI/D
// module chunks = 1